var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bx-layout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.49,
    height: 28.49,
    viewBox: "0 0 28.49 28.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    width: 28.49,
    height: 28.49,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M24.021,8.676a.23.23,0,0,1,0-.1.206.206,0,0,1,0-.085V8.386L23.948,8.2h0a.58.58,0,0,0-.109-.133l-.109-.1h-.06L18.906,4.965h0l-4.5-2.781A1.028,1.028,0,0,0,14.058,2h-.1a.991.991,0,0,0-.326,0h-.121a1.366,1.366,0,0,0-.4.157L4.083,7.782l-.109.085-.109.1-.121.085-.06.073h0L3.612,8.3v.181a.834.834,0,0,0,0,.242V19.28a1.209,1.209,0,0,0,.568,1.028l9.068,5.61h0l.181.073h.1a1.04,1.04,0,0,0,.629,0h.1l.181-.073h0l9-5.526A1.209,1.209,0,0,0,24,19.365V8.809A.657.657,0,0,0,24.021,8.676ZM13.756,4.626l2.152,1.33L9.149,10.139,6.985,8.809ZM12.547,22.762,5.9,18.7V10.974l6.65,4.111Zm1.209-9.806-2.309-1.39,6.759-4.2,2.321,1.439Zm7.859,5.707L14.965,22.8V15.085l6.65-4.111Z",
    transform: "translate(0.435 0.488)",
    fill: "#b5b5b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon);
export default __webpack_public_path__ + "static/media/box-icon.09f88efa14c46cf6ce8af12bbc46bbb1.svg";
export { ForwardRef as ReactComponent };